import React, { FC, useState } from "react";
import { Button, Col, Input, Row } from "antd";

import { IModal } from "@types";
import Modal from "@components/Modal";
import { ErrorServices, useCreateSubJobFunctionMutation } from "@services";

export interface IAddJobSubFunction extends IModal {
  job_function_id: string | number;
}

const AddJobSubFunction: FC<IAddJobSubFunction> = ({
  isVisible,
  setIsVisible,
  job_function_id,
}) => {
  const [jobFunction, setJobFunction] = useState("");
  const [createSubJobFunction, { isLoading }] =
    useCreateSubJobFunctionMutation();

  const onSubmit = async () => {
    try {
      await createSubJobFunction({
        name: jobFunction,
        job_function_id,
      }).unwrap();
      closeModal();
    } catch (error) {
      ErrorServices(error);
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setJobFunction(e.target.value);
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobFunction("");
  };

  return (
    <Modal
      width={544}
      footer={[
        <Button
          disabled={!jobFunction || isLoading}
          onClick={onSubmit}
          key="1"
          type="primary"
          loading={isLoading}
        >
          Add
        </Button>,
        <Button onClick={closeModal} key="2">
          Cancel
        </Button>,
      ]}
      title="Add a Job-Sub Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Sub-Job Function</label>
            <Input
              value={jobFunction}
              onChange={handleInput}
              size="large"
              placeholder="Name of the sub-job function here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default AddJobSubFunction;
